import { useEffect, useState } from 'react';
import { useSharedState } from '../hooks/useSharedState';
import styles from './SubscriptionForm.module.css'
import CategoryPicker from './CategoryPicker';
import { isValidEmail } from '../utils/EmailUtil';
import { useCategories } from '../hooks/useCategories';

function SubscriptionForm() {

    const [categories, setCategories] = useState<string[]>(['']);
    const [showCategories, setShowCategories] = useState<boolean>(false);
    const [period] = useSharedState('period', '');
    const [email ,setEmail] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [showSuccess, setShowSuccess] = useState<boolean>(false);
    const { categories: availableCategories } = useCategories();

    useEffect(() => {
        setErrorMessage('');
    }, [email]);

    const selectedCategoryLabel = () => {
        const selected = categories.filter(Boolean);
        if (selected.length === 0) {
            return 'Toutes';
        }

        return selected
            .map((slug) => availableCategories.find((category) => category.slug === slug)?.name ?? slug)
            .join(', ');
    };

    const subscribe = async () => {
        setIsLoading(true);
        let frequency = "weekly";
        if(parseInt(period) >=0 && parseInt(period) < 12) {
            frequency = "monthly";
        }
        try {
            let fetchUrl = '/api/subscriptions';
            const response = await fetch(fetchUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({subType: 'email', contact: email, category: categories.join(';'), frequency, city: "Québec"})
            });
            if(response.ok) {
                setEmail("");
                setShowSuccess(true);
            }
            else {
                setErrorMessage("Une erreur s'est produite.");
            }
            setIsLoading(false);
        } catch (error) {
            setErrorMessage("Une erreur s'est produite.");
            console.error('Error creating subscription:', error);
            setIsLoading(false);
        }
    };

    return <div className={styles.subscriptionBox}>
        
        {!showSuccess && <h1>Abonne-toi à notre infolettre personnalisée</h1>}
        {showSuccess && <h1>Tu es maintenant abonné.e!</h1>}

        <div>
            {!showSuccess && <>
                <p>Inspirations de bons plans et de découvertes locales directement dans ta boîte courriel.
                    Choisis tes catégories préférées — concerts, théâtre, expositions, événements familiaux et plus encore — et reçois chaque semaine une sélection sur mesure, directement dans ta boîte courriel.
                    <br/><br/>
                    🎉 C’est gratuit, sans engagement et facile à modifier en tout temps.
                </p>

                <div className={styles.categorySummaryRow}>
                    <div className={styles.categorySummaryLabel}>
                        Catégories: <strong>{selectedCategoryLabel()}</strong>
                    </div>
                    <button
                        type="button"
                        className={styles.toggleCategoriesBtn}
                        onClick={() => setShowCategories(current => !current)}
                    >
                        {showCategories ? 'Masquer les catégories' : 'Choisir des catégories'}
                    </button>
                </div>

                {showCategories && <CategoryPicker blue={true} selectedCategories={categories} onChange={(cats) => setCategories(cats.length ? cats : [''])} />}

            </>}

            {showSuccess && <p>Parfait! Surveille tes courriels pour la prochaine infolettre :)</p>}

            {!showSuccess && <div className={styles.flexBox}>
                <input type="email" placeholder='Entre ton courriel' readOnly={isLoading} onChange={(e) => setEmail(e.target.value)}/>
                <button type="button" className={styles.subscribeBtn} disabled={isLoading || !email || !isValidEmail(email)} onClick={subscribe}>Je m'abonne</button>
            </div>}

            {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}

        </div>
        

    </div>
}

export default SubscriptionForm;
